var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center","dense":""}},[(_vm.dataSource.series[0].data.length)?_c('v-col',{attrs:{"cols":"12","lg":"10","md":"10"}},[_c('MixedCarts',{attrs:{"dataSource":_vm.dataSource}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }